<template>
    <div
        v-if="loaded && session"
        class="game-responsive responsive_10x16">
        <betconstruct-frame :session="loaded ? session : null" />
    </div>
</template>
<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';

import BetconstructFrame from '../../../common/betconstruct/betconstruct-frame.vue';

export default {
    name: 'game-betconstruct',
    components: { BetconstructFrame },
    props: {
        gameId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            loaded: false,
            isMobile: isMobile.phone || isMobile.tablet
        };
    },
    computed: {
        isLoggedIn() {
            return Vue.state.player.isLoggedIn();
        },
        session() {
            return Vue.state.betconstruct.session.get();
        }
    },
    watch: {
        async $route() {
            await this.load();
        }
    },
    async created() {
        await Vue.state.player.ensure();
        await this.load();
    },
    methods: {
        async load() {
            this.loaded = false;

            if (this.isLoggedIn) {
                await Vue.state.betconstruct.session.open(this.gameId);
            } else {
                await Vue.state.betconstruct.session.openDemo(this.gameId);
            }

            if (this.isMobile) window.location.replace(this.session.sessionUrl);

            this.loaded = true;
        }
    },
    beforeDestroy() {
        this.loaded = false;
    }
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/game/game-betconstruct.vue